export default "__VITE_ASSET__BBUSCYWf__"